import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FiArrowRight } from "react-icons/fi";

export default function ProjectCard({ project, index }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 40 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.5, delay: index * 0.15 }}
      whileHover={{
        y: -6,
        boxShadow: "0 0 30px rgba(125,211,252,0.1)",
      }}
      className="bg-terminalLight rounded-2xl overflow-hidden border border-terminalBorder hover:border-accentBlue/40 transition-colors flex flex-col"
    >
      {project.thumbnail && (
        <div className="w-full h-44 overflow-hidden">
          <img
            src={project.thumbnail}
            alt={project.title}
            className="w-full h-full object-cover"
            loading="lazy"
          />
        </div>
      )}
      <div className="p-6 flex flex-col flex-1">
      <h3 className="text-xl font-semibold text-brightText mb-3">
        {project.title}
      </h3>
      <p className="text-dimText text-sm leading-relaxed flex-1 mb-4">
        {project.description}
      </p>
      <div className="flex flex-wrap gap-2 mb-4">
        {project.tags.map((tag) => (
          <span
            key={tag}
            className="px-3 py-1 text-xs font-mono font-medium rounded bg-terminal text-accentBlue border border-terminalBorder"
          >
            [{tag}]
          </span>
        ))}
      </div>
      <Link
        to={`/projects/${project.id}`}
        className="inline-flex items-center gap-2 text-sm font-medium text-accentBlue hover:text-neonBlue transition-colors"
      >
        View Details <FiArrowRight size={14} />
      </Link>
      </div>
    </motion.div>
  );
}
